import React from "react";
import {RCCGrid, RCCIcon} from "react-common-components";
import Card from "src/components/Card";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import DivGrouper from "src/components/ListCards/styles";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { checkSituationOccurrence, IOccurrence } from "../../interface";
import BadgeSituationOcurrences from "../BadgeOccurrences";
import { ICardOccurrence } from "./interface";
import DivWithWrap from "./styles";

const CardOccurences: React.FC<ICardOccurrence> = ({
	data,
	options,
	openModalAttachments,
	openModalHistory,
	openModalImmediateActions,
	refModalRegisterHistory
}) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const { translate, currentLanguage } = useTranslation();

	const colorCard = (dataOccurence: IOccurrence) => {
		let color: "blue" | "purple" | "red" | "green" | "grey" | "black";
	
		if(dataOccurence.late && (dataOccurence.ocb001Status === checkSituationOccurrence.OPENED || dataOccurence.ocb001Status === checkSituationOccurrence.NOT_STARTED)){
			color = "red";
		}else{
			switch(dataOccurence.ocb001Status){
			case checkSituationOccurrence.NOT_STARTED:
				color = "blue";
				break;
			case checkSituationOccurrence.OPENED:
				color = "purple";
				break;
			case checkSituationOccurrence.FINISHED:
				color = "green";
				break;
			case checkSituationOccurrence.CANCELED:
				color = "grey";
				break;
			case checkSituationOccurrence.DISAPPROVED:
				color = "black";
				break;
			default: 
				color = "green";
				break;
			}
		}
		return color;
	};

	

	const currentStage = (row: any) => {
		let text = "";
		switch(row.ocb001Status){
		case checkSituationOccurrence.FINISHED:
			text = "Finalizada";
			break;
		case checkSituationOccurrence.CANCELED:
			text = "Cancelada";
			break;
		case checkSituationOccurrence.DISAPPROVED:
			text = "Reprovada";
			break;
		default: 
			text = row.oca003Descricao;
			break;
		}
		return text;
	};

	return (
		<>
			<DivGrouper>
				<InfiniteScrollWithoutFetch 
					listElements={data}
					mapper={(occurrence : IOccurrence) => (
						<Card
							color={colorCard(occurrence)}
							options={options(occurrence)}
							title={`${occurrence.fullTitle}`}
							hidePercentage
							key={`${occurrence.ocb001Id}`}
						>
							<RCCGrid container item alignItems="center" >
							
								<DivWithWrap style={occurrence.ocb001Data !== null ? { flexDirection: "column", alignItems: "baseline" } : {}}>
									<DivWithWrap>
										<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
										{formatDate(occurrence.ocb001Data, currentLanguage)}
										
									</DivWithWrap>
								</DivWithWrap>	
								<DivWithWrap style={{marginRight: "0.5rem"}}>
									<Photo 
										name={occurrence.ocb001Efa005Nome2}
										link={occurrence.ocb001Efa005Imagem2 && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${occurrence.ocb001Efa005Imagem2}`}
										hover
									/>
									{occurrence.ocb001Efa005Nome2}
								</DivWithWrap>					
							</RCCGrid>

							<p><b>{`${translate("Etapa atual")}: `}</b> {translate(currentStage(occurrence))}</p>
							<p><b>{`${translate("Requisito")}: `}</b>{`${translate(occurrence.oca001Descricao)}`}</p>
							<p><b>{`${translate("Origem")}: `}</b>{`${occurrence.oca002Descricao}`}</p>
							<p><b>{`${translate("Categoria")}: `}</b> {`${occurrence.oca004Descricao}`}</p>

							<RCCGrid container item alignItems="center" >
								<DivWithWrap>
									<BadgeSituationOcurrences 
										ocurrence={occurrence}
										refModalRegisterHistory={refModalRegisterHistory}
										openModalAttachments={openModalAttachments}
										openModalHistory={openModalHistory}
										openModalImmediateActions={openModalImmediateActions}
									/>	
								</DivWithWrap>
							</RCCGrid>
							

						</Card>	
					)}
				/>		
			</DivGrouper>
		</>
	);

};

export default CardOccurences;
